<template>
  <v-img :lazy-src="url" :src="url" :height="height" :width="width" @click="$emit('click')">
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
      </v-row>
    </template>
  </v-img>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    height: [Number, String],
    width: [Number, String],
  },
}
</script>
